/**
 * Conversion signal for ad platforms.
 *
 * This is NOT analytics. Google's Smart Bidding and Meta's optimiser need to
 * know which clicks became leads, or they optimise for clicks and burn budget.
 * Nothing here fires unless a tag is actually installed, so the plumbing can
 * ship before the ad accounts exist and start working the day they do.
 *
 * To turn it on later, add ONE of these to public/index.html:
 *   - Google Tag Manager  → trigger on the custom event "lead_submitted"
 *   - Google Ads gtag.js  → the gtag("event") call below fires automatically
 *   - Meta Pixel          → the fbq("track","Lead") call fires automatically
 *
 * Deliberately carries NO personal data — no name, phone or email. Ad
 * platforms get the campaign context they need to optimise and nothing else.
 */
export function trackConversion(lead = {}) {
  const payload = {
    event: "lead_submitted",
    pest: lead.pest || null,
    city: lead.city || null,
    zip_code: lead.zip_code || null,
    urgency: lead.urgency || null,
    utm_source: lead.utm_source || null,
    utm_medium: lead.utm_medium || null,
    utm_campaign: lead.utm_campaign || null,
    page: typeof window !== "undefined" ? window.location.pathname : null,
  };

  // Google Tag Manager. Queue survives GTM loading late.
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  } catch {
    /* no-op */
  }

  // Google Ads / GA4 direct gtag.
  try {
    if (typeof window.gtag === "function") {
      window.gtag("event", "lead_submitted", payload);
    }
  } catch {
    /* no-op */
  }

  // Meta Pixel standard Lead event.
  try {
    if (typeof window.fbq === "function") {
      window.fbq("track", "Lead", {
        content_category: payload.pest || undefined,
        content_name: payload.city || undefined,
      });
    }
  } catch {
    /* no-op */
  }

  return payload;
}
